var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Button, CardMedia, Link, Typography, } from '@one-thd/sui-atomic-components';
import { Returns } from '@one-thd/sui-icons';
import classNames from 'classnames';
import React, { useState } from 'react';
import { pushEventInfo } from '../../utils/analytics';
import { getBIAFulfillmentLocation, getBIAFulfillmentMethod, } from '../../utils/buy-it-again';
import { generateImageUrl, getHost } from '../../utils/general';
import { checkSingleItemProtectionPlanReturn, getItemReturnWindow, getQuantityByStatus, } from '../../utils/order-details/LineItemUtils';
import { getReturnStatus } from '../../utils/order-details/OrderDetailsUtils';
import { consolidateLineItems } from '../../utils/shared/LineItemUtils';
import { AlertBanner } from '../shared/alert-banner/AlertBanner';
import { CustomImage } from '../shared/CustomImage';
import { BopisOutOfStockButton } from './BOPISOutOfStock/BopisOutOfStockButton';
import { SubstitutionDetails } from './BOPISSubstitutions/SubstitutionDetails';
import BuyItAgainButton from './BuyItAgainButton/BuyItAgainButton';
import HomeDepotProtectionPlan from './HDPP/HomeDepotProtectionPlan';
import { InfoAndGuidesPopover } from './InfoAndGuidesPopover/InfoAndGuidesPopover';
import { PartsAndServices } from './PartsAndServices/PartsAndServices';
import { getOrderStatus } from './util/FulfillmentStatus';
import { LineItemPricing } from './util/LineItemPricing';
import { SubstitutionBadges, } from './BOPISSubstitutions/SubstitutionBadges';
import { FeatureSwitches } from '../../constants/feature-switches';
// is this going to be the attribute named 'description' from the response?
// const isSubscriptionEligible = true;
// const subscriptionDefaultFrequency = '3_3'; // will get this from the line item if isSubscriptionEligible= true
var partsAndServicesList = [
    'APPLIANCE PARTS',
    'Home Delivery',
    'DELIVERY',
    'Otr Install',
    'Haul Away Your Old Appliance',
    'Dishwasher Install',
    'Dishwasher 110v Cord',
    'Dishwasher Parts Kit & Adapter',
    'Naturalgas Range Install',
    'Move Old Appl To Another Room',
    'Nat Gas Range Parts Kit',
    'Range Power Cord',
    'HDPP REPLACEMENT',
];
var renderBopisOutOfStockButton = function (fulfillmentGroup, open, setOpen) {
    var _a;
    return (React.createElement("div", { className: "sui-my-4" }, ((_a = fulfillmentGroup.actions) === null || _a === void 0 ? void 0 : _a.isOosRecoveryEnabled) && (React.createElement(BopisOutOfStockButton, { open: open, setOpen: setOpen }))));
};
var renderBuyItAgainButton = function (item, isAAFESOrder, isNEXOrder, isFirstShipment, fulfillmentGroup) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    if (isAAFESOrder || isNEXOrder)
        return null;
    if (!((_a = item === null || item === void 0 ? void 0 : item.actions) === null || _a === void 0 ? void 0 : _a.buyAgain) ||
        (item === null || item === void 0 ? void 0 : item.productType) === 'EPP' ||
        (item === null || item === void 0 ? void 0 : item.isGiftCard))
        return null;
    if (!isFirstShipment)
        return null;
    var applianceStoreId = ((_d = (_c = (_b = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.shippingAndHandling) === null || _b === void 0 ? void 0 : _b.applianceDeliveries) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.storeId) ||
        ((_g = (_f = (_e = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.bodfsDeliveryAndHandling) === null || _e === void 0 ? void 0 : _e.bodfsDeliveries) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.storeId);
    return (React.createElement(BuyItAgainButton, { fulfillmentLocation: getBIAFulfillmentLocation(item.productType), fulfillmentType: getBIAFulfillmentMethod(item.productType), isSubscriptionEligible: (_h = item.actions) === null || _h === void 0 ? void 0 : _h.isSubscriptionEligible, itemId: (_j = item.omsId) !== null && _j !== void 0 ? _j : item.secOmsId, quantity: getQuantityByStatus(item), subscriptionDefaultFrequency: item.subscriptionDefaultFrequency, applianceStoreId: applianceStoreId }));
};
var paintHistoryClick = function () {
    pushEventInfo({
        category: { primaryCategory: 'stash' },
        eventInfo: { eventName: 'my account settings' },
        stash: {
            myAccount: {
                settings: 'purchase history: order details: view paint purchase history',
            },
        },
        eventMode: 'stash',
    });
};
/**
 * If lineItem is a liquid paint and fs is enabled then show alert with cta
 * @returns Stencil Alert component that shows message and link to paint purchase history page.
 */
var liquidPaintAlertCTA = function (item) {
    var _a;
    if ((_a = item === null || item === void 0 ? void 0 : item.actions) === null || _a === void 0 ? void 0 : _a.isLiquidPaint) {
        return (React.createElement(AlertBanner, { status: "info" },
            "If you ordered tinted paint in store, you can reorder online on the",
            ' ',
            React.createElement(Link, { href: "/myaccount/paintPurchaseHistory", variant: "body-base", onClick: paintHistoryClick },
                ' ',
                "Paint Purchase History"),
            ' ',
            "page."));
    }
    return null;
};
var renderBopisSubstitutionBadge = function (item, fulfillmentGroup) {
    if (!FeatureSwitches.enableBopisOutOfStockSubstitution ||
        (fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.fulfillmentType) === 'CanceledItems' ||
        (item === null || item === void 0 ? void 0 : item.statusDescription) === 'Canceled') {
        return null;
    }
    var badgeType = '';
    if (item === null || item === void 0 ? void 0 : item.isSubstituted) {
        badgeType = 'Substituted Item';
    }
    else if (item === null || item === void 0 ? void 0 : item.isSubstitutable) {
        badgeType = 'Substitute if out of stock';
    }
    return badgeType ? React.createElement(SubstitutionBadges, { type: badgeType }) : null;
};
var renderLineItems = function (lineItems, partsAndServices, isAAFESOrder, isNEXOrder, isFirstShipment, isSoris, fulfillmentGroup, isSingleItemReturn, isBopisOutOfStock) {
    var newLineItems;
    if (fulfillmentGroup.fulfillmentType === 'InStorePurchase') {
        newLineItems = consolidateLineItems(lineItems);
    }
    var fulfillmentType = fulfillmentGroup.fulfillmentType;
    return (fulfillmentGroup.fulfillmentType === 'InStorePurchase'
        ? newLineItems !== null && newLineItems !== void 0 ? newLineItems : lineItems
        : lineItems).map(function (item, index) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var combineLineItemsAgain = __spreadArray(__spreadArray([], lineItems, true), partsAndServices, true);
        var filterPartsAndServices = combineLineItemsAgain.filter(function (lineItem) {
            var parentLine = lineItem === null || lineItem === void 0 ? void 0 : lineItem.parentLine;
            return parentLine && parentLine.lineId === item.lineId;
        });
        // TODO Remove returnWindowMessage later once UPS barcode is permanently enabled
        var deliveryStatusCode = item.statusCode;
        // returnByDate - end date for the initiated return attempt
        // returnWindowEndDate - end date for the item return window eligibilty
        var returnByDate = item.returnByDate, returnWindowEndDate = item.returnWindowEndDate;
        var returnTrackingList = item.returnOrderTrackingInfo;
        var returnWindowMessage = getItemReturnWindow(deliveryStatusCode, returnWindowEndDate, returnByDate, returnTrackingList, isSoris);
        var _k = getReturnStatus(fulfillmentGroup), isInitiatedReturn = _k.isInitiatedReturn, isInProgressReturn = _k.isInProgressReturn;
        var shouldRenderReturnWindowMessage = returnWindowMessage && !isInitiatedReturn && !isInProgressReturn;
        var isCancelledOrReturn = getOrderStatus((item === null || item === void 0 ? void 0 : item.statusCode) || 0).isCancelledOrReturn;
        var itemImage = function () {
            var _a;
            return (React.createElement(CustomImage, { src: (_a = generateImageUrl(item)) !== null && _a !== void 0 ? _a : '', alt: item === null || item === void 0 ? void 0 : item.description, lazy: true }));
        };
        var itemDetails = (React.createElement(React.Fragment, null,
            React.createElement("span", { className: "sui-font-bold sui-pr-1" }, (_a = item.brandName) === null || _a === void 0 ? void 0 : _a.toUpperCase()),
            React.createElement("span", null, (_c = (_b = item === null || item === void 0 ? void 0 : item.description) !== null && _b !== void 0 ? _b : item === null || item === void 0 ? void 0 : item.subClassName) !== null && _c !== void 0 ? _c : 'Item Description Unavailable')));
        return (React.createElement("div", { "data-testid": "lineitems", key: index },
            React.createElement("div", { className: classNames('sui-flex sui-flex-col', {
                    'sui-mb-0': index === lineItems.length - 1,
                    'sui-mb-6 md:sui-mb-8': index !== lineItems.length - 1,
                }) },
                shouldRenderReturnWindowMessage && (React.createElement("div", { style: {
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '0.8rem',
                    } },
                    React.createElement(Returns, { color: "medium", size: "small", style: { margin: '0 8px' } }),
                    React.createElement(Typography, { height: "tight" },
                        React.createElement("div", { className: "return-window-text" }, returnWindowMessage)))),
                renderBopisSubstitutionBadge(item, fulfillmentGroup),
                React.createElement("div", { className: classNames('sui-flex sui-flex-col', {
                        'sui-mb-0': index === lineItems.length - 1,
                        'sui-mb-6 md:sui-mb-0': index !== lineItems.length - 1,
                    }) },
                    React.createElement("div", { className: "sui-flex sui-mb-4" },
                        React.createElement("div", { className: "sui-mr-4 sui-mt-1" },
                            React.createElement("div", { style: { width: '70px', height: '70px' } },
                                React.createElement(CardMedia, { component: itemImage }))),
                        React.createElement("div", { className: "sui-flex sui-flex-col sui-items-start" },
                            item.pipSeoUrl ? (React.createElement(Link, { href: "".concat(getHost()).concat(item.pipSeoUrl), variant: "body-base" }, itemDetails)) : (React.createElement(Typography, null, itemDetails)),
                            isFirstShipment && (React.createElement("div", { className: "sui-mt-2 " },
                                React.createElement(Typography, null,
                                    "Qty: ",
                                    getQuantityByStatus(item, fulfillmentType)))),
                            isFirstShipment && LineItemPricing(item),
                            isFirstShipment &&
                                ![
                                    'Returned',
                                    'Return Initiated',
                                    'ReturnInProgress',
                                ].includes((_d = item === null || item === void 0 ? void 0 : item.statusDescription) !== null && _d !== void 0 ? _d : '') &&
                                ((_e = item === null || item === void 0 ? void 0 : item.actions) === null || _e === void 0 ? void 0 : _e.infoAndGuides) &&
                                (item === null || item === void 0 ? void 0 : item.documents) &&
                                ((_f = item === null || item === void 0 ? void 0 : item.documents) === null || _f === void 0 ? void 0 : _f.length) > 0 &&
                                !(item === null || item === void 0 ? void 0 : item.isGiftCard) && (React.createElement(InfoAndGuidesPopover, { documents: item === null || item === void 0 ? void 0 : item.documents, internetSKU: item === null || item === void 0 ? void 0 : item.omsId, modelNumber: item === null || item === void 0 ? void 0 : item.modelNumber, storeSKU: (item === null || item === void 0 ? void 0 : item.storeSKU) || (item === null || item === void 0 ? void 0 : item.skuNumber) })))),
                    !isBopisOutOfStock &&
                        !item.isGiftCard &&
                        isFirstShipment &&
                        liquidPaintAlertCTA(item),
                    !isBopisOutOfStock &&
                        !((_g = item.description) === null || _g === void 0 ? void 0 : _g.includes('PROTECTION PLAN')) &&
                        renderBuyItAgainButton(item, isAAFESOrder, isNEXOrder, isFirstShipment, fulfillmentGroup),
                    ((item === null || item === void 0 ? void 0 : item.fileAClaim) || (item === null || item === void 0 ? void 0 : item.productType) === 'EPP') &&
                        !isSingleItemReturn &&
                        !isCancelledOrReturn && (React.createElement("div", { className: "sui-flex sui-flex-col sui-space-y-4 sui-my-4 sui-w-full card-fix" },
                        React.createElement(Button, { variant: "secondary", href: "https://www.squaretrade.com/thd/", target: "_blank" }, "File A Claim"))),
                    isFirstShipment &&
                        ((_h = item === null || item === void 0 ? void 0 : item.actions) === null || _h === void 0 ? void 0 : _h.isProtectionPlanEligible) &&
                        !isCancelledOrReturn &&
                        !isAAFESOrder &&
                        !isNEXOrder && (React.createElement(HomeDepotProtectionPlan, { omsId: item === null || item === void 0 ? void 0 : item.omsId, originalUnitPrice: item === null || item === void 0 ? void 0 : item.unitPrice, originalOrderedQuantity: (_j = item === null || item === void 0 ? void 0 : item.originalOrderedQuantity) !== null && _j !== void 0 ? _j : item === null || item === void 0 ? void 0 : item.orginalOrderedQuantity })),
                    FeatureSwitches.enableBopisOutOfStockSubstitution &&
                        (item === null || item === void 0 ? void 0 : item.substitutionItem) && React.createElement(SubstitutionDetails, { item: item }),
                    !isBopisOutOfStock && !item.isGiftCard && isFirstShipment && (React.createElement(PartsAndServices, { items: filterPartsAndServices }))))));
    });
};
export var LineItems = function (_a) {
    var orderDetailsData = _a.orderDetailsData, lineItems = _a.lineItems, isFirstShipment = _a.isFirstShipment, _b = _a.isSoris, isSoris = _b === void 0 ? false : _b, fulfillmentGroup = _a.fulfillmentGroup, isBopisOutOfStock = _a.isBopisOutOfStock;
    var _c = orderDetailsData !== null && orderDetailsData !== void 0 ? orderDetailsData : {
        fulfillmentGroups: [],
        isAAFESOrder: false,
        isNEXOrder: false,
    }, _d = _c.isAAFESOrder, isAAFESOrder = _d === void 0 ? false : _d, _e = _c.isNEXOrder, isNEXOrder = _e === void 0 ? false : _e;
    var isSingleItemReturn = checkSingleItemProtectionPlanReturn(orderDetailsData);
    var filteredLineItems = [];
    var partsAndServices = [];
    var hasApplianceItem = lineItems === null || lineItems === void 0 ? void 0 : lineItems.some(function (item) { return (item === null || item === void 0 ? void 0 : item.productType) === 'MAJOR_APPLIANCE'; });
    var _f = useState(false), open = _f[0], setOpen = _f[1];
    if (lineItems) {
        lineItems.forEach(function (item) {
            var _a, _b, _c, _d;
            if (((_a = item === null || item === void 0 ? void 0 : item.parentLine) === null || _a === void 0 ? void 0 : _a.relationType) === 'COMBO')
                return;
            if ((item === null || item === void 0 ? void 0 : item.parentLine) !== undefined &&
                (partsAndServicesList.includes((_b = ((item === null || item === void 0 ? void 0 : item.className) || (item === null || item === void 0 ? void 0 : item.description))) !== null && _b !== void 0 ? _b : '') ||
                    ((_c = item.parentLine) === null || _c === void 0 ? void 0 : _c.relationType) === 'PARTS' ||
                    ((_d = item.parentLine) === null || _d === void 0 ? void 0 : _d.relationType) === 'SERVICE') &&
                hasApplianceItem) {
                partsAndServices.push(item);
            }
            else {
                filteredLineItems.push(item);
            }
        });
        return (React.createElement("div", { className: classNames('sui-flex sui-flex-col sui-grid sui-order-2 md:sui-order-1') },
            renderLineItems(filteredLineItems, partsAndServices, isAAFESOrder, isNEXOrder, isFirstShipment, isSoris, fulfillmentGroup, isSingleItemReturn, isBopisOutOfStock),
            isBopisOutOfStock &&
                renderBopisOutOfStockButton(fulfillmentGroup, open, setOpen)));
    }
    return null;
};
